import { render, staticRenderFns } from "./MicroList.vue?vue&type=template&id=415911e0&scoped=true&"
import script from "./MicroList.vue?vue&type=script&lang=js&"
export * from "./MicroList.vue?vue&type=script&lang=js&"
import style0 from "./MicroList.vue?vue&type=style&index=0&id=415911e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415911e0",
  null
  
)

export default component.exports